var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "d-flex align-items-center" }, [
    _c("div", { staticClass: "flex-grow-1 d-flex flex-column" }, [
      _c("div", [_vm._v(_vm._s(_vm.name))]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex-shrink-0" },
      [
        _c(
          "el-popover",
          { attrs: { placement: "top-end", width: "300", trigger: "click" } },
          [
            _c("div", { staticClass: "word-break-normal" }, [
              _vm._v(_vm._s(_vm.description)),
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-secondary btn-sm",
                attrs: { slot: "reference" },
                slot: "reference",
              },
              [_c("i", { staticClass: "fas fa-info fa-fw" })]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }